var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModoAvaliacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 80,
    viewBox: "0 0 47 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilustra\xC3\xA7\xC3\xA3o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 34",
    d: "M0 7.48926H20.767H22.0649M0 13.9789H14.2773",
    stroke: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 35",
    d: "M0 1H20.767H22.0649",
    stroke: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 253",
    y: 56.1787,
    width: 7.78762,
    height: 23.3629,
    fill: "#00D084"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 254",
    x: 12.9795,
    y: 61.3701,
    width: 7.78762,
    height: 18.1711,
    fill: "#797D8D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 255",
    x: 25.959,
    y: 53.583,
    width: 7.78762,
    height: 25.9587,
    fill: "#00D084"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 256",
    x: 38.6611,
    y: 23.7422,
    width: 8.33871,
    height: 56.0968,
    fill: "#001574"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 36",
    d: "M0 38.1455H44.2353H47",
    stroke: "#B3B3B3",
    strokeMiterlimit: 16,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    d: "M4.15782 27.3734L2.45884 23.8955H0.273485L2.99852 28.706L0.200195 33.5964H2.4122L4.18448 30.0651L5.96341 33.5964H8.14877L5.35044 28.706L8.08214 23.8955H5.88346L4.15782 27.3734Z",
    fill: "#001574"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModoAvaliacao);
export default __webpack_public_path__ + "static/media/modo_avaliacao.a8fc61ebb1957a980d00b9a539840157.svg";
export { ForwardRef as ReactComponent };